import styles from './SolutionPickerModule.module.scss';

import cx from 'classnames';
import type { ReferencedEntry } from 'contentful';
import React, { FC, HTMLAttributes } from 'react';

import type { SolutionPickerModule as SolutionPickerModuleType } from 'api/contentful/contentTypes.cloverdotcom';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { flattenContentfulData, FlatEntry } from 'services/cms/flattenContentful';
import { SolutionDefault } from './Default/SolutionDefault';
import { SolutionFlat as SolutionFlatMobile } from './Flat/Mobile/SolutionFlat';
import { SolutionFlat } from './Flat/SolutionFlat';
interface ISolutionPickerModuleProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<SolutionPickerModuleType>;
}

const SolutionPickerModule: FC<ISolutionPickerModuleProps> = ({ entry, style = {}, className, ...props }) => {
  const { browser } = useBreakpoints();
  const isMobile = browser.is.mobile;

  if (!entry) return null;

  const { backgroundColor, variant } = entry;
  const SolutionPickerModuleFlat = isMobile ? SolutionFlatMobile : SolutionFlat;
  const SolutionPickerModule = variant === 'Default' ? SolutionDefault : SolutionPickerModuleFlat;

  return (
    <section
      className={cx(styles.solutionPickerModule, className)}
      style={{ ...style, backgroundColor: backgroundColor || style.backgroundColor }}
      {...props}
      aria-label={entry.title}
    >
      <SolutionPickerModule entry={entry} />
    </section>
  );
};

SolutionPickerModule.displayName = 'SolutionPickerModule';

interface ISolutionPickerModuleWrapperProps extends HTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<SolutionPickerModuleType>;
}

const SolutionPickerModuleWrapper: FC<ISolutionPickerModuleWrapperProps> = ({ entry, ...props }) => (
  <SolutionPickerModule {...props} entry={flattenContentfulData(entry)} />
);

SolutionPickerModuleWrapper.displayName = 'SolutionPickerModuleWrapper';

export { SolutionPickerModuleWrapper as SolutionPickerModule };
